// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__233Kl","field":"styles_field__bSTUv","fieldCol":"styles_fieldCol__25uXF","diffCol":"styles_diffCol__OR6bc","diff":"styles_diff__2VZ11"};